import React, { useState, createRef } from "react";
import "./ExperienceCard.scss";
import ColorThief from "colorthief";
import { useTranslation } from 'react-i18next';

export default function ExperienceCard({ cardInfo, isDark }) {
  const { t } = useTranslation();
  const [colorArrays, setColorArrays] = useState([]);
  const imgRef = createRef();

  function getColorArrays() {
    const colorThief = new ColorThief();
    setColorArrays(colorThief.getColor(imgRef.current));
  }

  function rgb(values) {
    return typeof values === "undefined"
      ? null
      : "rgb(" + values.join(", ") + ")";
  }

  // Process descBullets (regular responsibilities) - Updated for new toolsSection structure
  let listBullets = [];

  if (cardInfo.descBullets && Array.isArray(cardInfo.descBullets)) {
    cardInfo.descBullets.forEach((item, i) => {
      if (item !== "") {
        listBullets.push({ item, i });
      }
    });
  }

  // Function to get localized content for specific companies
  const getLocalizedContent = () => {
    if (cardInfo.company === "Joblogic") {
      return {
        desc: t('experience.joblogic.desc'),
        heading: t('experience.joblogic.heading'),
        descBullets: [
          t('experience.joblogic.point1'),
          t('experience.joblogic.point2'),
          t('experience.joblogic.point3'),
          t('experience.joblogic.point4'),
          t('experience.joblogic.point5'),
          t('experience.joblogic.point6')
        ],
        toolsSection: {
          heading: t('experience.joblogic.toolsTitle'),
          items: [
            t('experience.joblogic.tool1'),
            t('experience.joblogic.tool2'),
            t('experience.joblogic.tool3')
          ]
        }
      };
    } else if (cardInfo.company === "YumyApps") {
      return {
        desc: t('experience.yumyapps.desc'),
        heading: t('experience.yumyapps.heading'),
        descBullets: [
          t('experience.yumyapps.point1'),
          t('experience.yumyapps.point2'),
          t('experience.yumyapps.point3'),
          t('experience.yumyapps.point4'),
          t('experience.yumyapps.point5'),
          t('experience.yumyapps.point6')
        ],
        toolsSection: cardInfo.toolsSection // Use original if no localized version
      };
    } else if (cardInfo.company === "Vespert Tech") {
      return {
        desc: t('experience.vespert.desc'),
        heading: t('experience.vespert.heading'),
        descBullets: [
          t('experience.vespert.point1'),
          t('experience.vespert.point2'),
          t('experience.vespert.point3'),
          t('experience.vespert.point4'),
          t('experience.vespert.point5'),
          t('experience.vespert.point6')
        ],
        toolsSection: cardInfo.toolsSection // Use original if no localized version
      };
    }
    // Return original content for other companies
    return cardInfo;
  };

  const localizedCardInfo = getLocalizedContent();

  // Update listBullets to use localized content
  listBullets = [];
  if (localizedCardInfo.descBullets && Array.isArray(localizedCardInfo.descBullets)) {
    localizedCardInfo.descBullets.forEach((item, i) => {
      if (item !== "") {
        listBullets.push({ item, i });
      }
    });
  }

  return (
    <div className={isDark ? "experience-card-dark" : "experience-card"}>
      <div style={{ background: rgb(colorArrays) }} className="experience-banner">
        <div className="experience-blurred_div"></div>
        <div className="experience-div-company">
          <h5 className="experience-text-company">{cardInfo.company}</h5>
        </div>

        <img
          crossOrigin={"anonymous"}
          ref={imgRef}
          className="experience-roundedimg"
          src={cardInfo.companylogo}
          alt={cardInfo.company}
          onLoad={() => getColorArrays()}
        />
      </div>
      <div className="experience-text-details">
        <h5
          className={
            isDark
              ? "experience-text-role dark-mode-text"
              : "experience-text-role"
          }
        >
          {cardInfo.role}
        </h5>
        <h5
          className={
            isDark
              ? "experience-text-date dark-mode-text"
              : "experience-text-date"
          }
        >
          {cardInfo.date}
        </h5>
         <p
          className={
            isDark
              ? "subTitle experience-text-desc dark-mode-text"
              : "subTitle experience-text-desc"
          }
        >
          {localizedCardInfo.desc}
        </p>

          <p
          className={
            isDark
              ? "experience-text-heading dark-mode-text"
                : "experience-text-heading"
          }
        >
          {localizedCardInfo.heading}
        </p>

        <ul>
          {listBullets.map(({ item, i }) => {
            if (item === "") {
              return <div key={i} style={{ height: '10px' }}></div>;
            }
            return (
              <li
                key={i}
                className={isDark ? 'subTitle dark-mode-text' : 'subTitle'}
              >
                {item}
              </li>
            );
          })}
        </ul>

        {/* Render Tools Section if it exists */}
        {localizedCardInfo.toolsSection && (
          <div>
            <p
              className={
                isDark
                  ? "experience-text-heading dark-mode-text"
                  : "experience-text-heading"
              }
            >
              {localizedCardInfo.toolsSection.heading}
            </p>
            <ul>
              {localizedCardInfo.toolsSection.items.map((item, i) => (
                <li
                  key={i}
                  className={isDark ? 'subTitle dark-mode-text' : 'subTitle'}
                >
                  {item}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}